<template>
  <div class="activity-details-container">
    <!-- Loading State -->
    <div v-if="loading" class="text-center py-4">
      <b-spinner small class="mr-2"></b-spinner>
      <span class="text-muted">Loading activity details...</span>
    </div>

    <!-- No Data Found State -->
    <div v-else-if="!task || Object.keys(task).length === 0" class="text-center py-4">
      <p class="text-muted">No data found.</p>
    </div>

    <!-- Activity Details Content -->
    <div v-else class="activity-content">
      <div class="d-flex align-items-center mb-4">
        <div class="p-2 rounded w-100" :style="{ backgroundColor: task.color + '22', borderLeft: '5px solid ' + task.color }">
          <h4 class="mb-0 fw-bold" :style="{ color: task.color }">{{ task.title }}</h4>
        </div>
      </div>

      <div class="mb-3">
        <label class="text-muted small fw-bold mb-1 text-uppercase">Student</label>
        <p class="mb-0 fw-bold text-primary">{{ task.studentName }}</p>
      </div>

      <div v-if="task.description" class="mb-3">
        <label class="text-muted small fw-bold mb-1 text-uppercase">Description</label>
        <div class="p-3 bg-light rounded">
          <p class="mb-0 text-dark description-text">{{ task.description }}</p>
        </div>
      </div>

      <div class="fw-bold">
        <label class="text-muted small fw-bold mb-1 text-uppercase">Other Meeting Attendees</label>
        <p class="mb-0 text-dark" style="line-height: 1.6; white-space: pre-wrap;"> {{ task.raw.cc_email }} </p>
      </div><br>

      <div class="mb-3">
        <label class="text-muted small fw-bold mb-1 text-uppercase">Date & Time</label>
        <p class="mb-0">
          <i class="fa fa-calendar mr-2 text-primary"></i>
          {{ formatFullDate(task.start) }}
        </p>
        <p class="mb-0">
          <i class="fa fa-clock-o mr-2 text-primary pr-1"></i>
          {{ task.time || 'All Day' }}
        </p>
      </div>

      <div class="text-right mt-4">
        <b-button variant="light" @click="closeModal">Close</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment"
import { SpcmCalendarCategorys } from "../FackApi/api/SpcmCalendarCategory"
import { SpcmSessions } from "../FackApi/api/spcmSession"
export default {
  name: "SpcmActivityDetails",
  props: {
    propActivity: {
      type: Object,
      default: () => ({})
    },
    propSessionId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      task: null,
      loading: false,
      error: null,
      spcmCalendarCategory: []
    }
  },
  mounted () {
    if (this.propActivity && Object.keys(this.propActivity).length > 0) {
      this.task = this.propActivity
    }
    else if (this.propSessionId) {
      this.spcmSessionView()
    }
  },
  methods: {
    /**
     * formatFullDate - Format date to readable format
     */
    formatFullDate (date) {
      return moment(date).format("MMMM Do, YYYY")
    },
    /**
     * closeModal - Emit event to close parent modal
     */
    closeModal () {
      this.$emit("emitCloseActivityDetails")
    },
    /**
     * SpcmCalendarCategoryList
     */
    async SpcmCalendarCategoryList () {
      let resp = await SpcmCalendarCategorys.SpcmCalendarCategoryList(this)
      if (resp && resp.resp_status) {
        this.spcmCalendarCategory = resp.resp_data.data
      }
    },
    /**
     * getCategoryColor
     */
    getCategoryColor (categoryName) {
      if (!categoryName) return "#00cec9" // Default color
      const category = this.spcmCalendarCategory.find(
        cat => cat.category_name.toLowerCase() === categoryName.toLowerCase()
      )

      return category ? category.color_code : "#00cec9"
    },
    /**
     * spcmSessionView
     */
    async spcmSessionView () {
      try {
        if (this.propSessionId) {
          let spcmSessionViewResp = await SpcmSessions.spcmSessionView(this, this.propSessionId)
          if (spcmSessionViewResp && spcmSessionViewResp.resp_status) {
            let meetingDetails = spcmSessionViewResp.resp_data.data
            const startMoment = moment.unix(meetingDetails.session_start_ts)
            const themeColor = this.getCategoryColor(meetingDetails.category)
            this.task = {
              id: meetingDetails.spcm_calendar_id,
              title: meetingDetails.session_title,
              category: meetingDetails.category,
              description: meetingDetails.description,
              start: startMoment.format("YYYY-MM-DD"),
              time: startMoment.format("hh:mm A"),
              backgroundColor: themeColor,
              borderColor: themeColor,
              textColor: "#ffffff",
              color: themeColor,
              studentId: meetingDetails.user_id,
              studentName: meetingDetails.student_name,
              raw: {
                cc_email: meetingDetails.cc_email
              }
            }
          }
          else {
            this.task = null
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at spcmSessionView() and Exception:", err.message)
      }
    }
  }
}
</script>
